module.exports = __webpack_public_path__ + "static/img/bluelogozh.b865e4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bluelogozh.png
// module id = bMvu
// module chunks = 1